<template>
  <div
    class="charge-order-tips"
    :class="bannerListLength > 0 ? 'ban-top' : ''"
    v-if="orderList.length > 0"
  >
    <div class="charge-order-tips-box">
      <div class="charge-order-icon-box">
        <img
          src="../../../../picture/index/order-icon.png"
          class="charge-order-icon"
        />
      </div>
      <div class="charge-order-flex">
        <div class="charge-order-len">您有 {{ orderList.length }} 条订单：</div>
        <div class="order-list">
          <van-swipe
            v-if="orderList.length > 1"
            class="swiper-box"
            :show-indicators="false"
            :autoplay="3000"
            :vertical="true"
          >
            <van-swipe-item
              v-for="(item, index) in orderList"
              :key="index + '~' + item.orderNo"
            >
              <div class="order-item" @click="goOrder(item)">
                {{ item.pileName }}-{{
                  item.gunNumber == "1" ? "A" : "B"
                }}枪正在充电中
                <span class="charge-soc" v-if="item.soc"
                  >已充电{{ item.soc }}％</span
                >
              </div>
            </van-swipe-item>
          </van-swipe>
          <template v-else>
            <div
              v-for="(item, index) in orderList"
              :key="index + '~' + item.orderNo"
              class="order-item"
              @click="goOrder(item)"
            >
              {{ item.pileName }}-{{
                item.gunNumber == "1" ? "A" : "B"
              }}枪正在充电中
              <span class="charge-soc" v-if="item.soc"
                >已充电{{ item.soc }}％</span
              >
            </div>
          </template>
        </div>
      </div>
      <div class="v-center">
        <div class="right-arrow"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderStatusGoPage } from "@/common/common-data";
import { Swipe, SwipeItem } from "vant";
export default {
  name: "pi-home-order-tips",
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  props: {
    bannerListLength: {
      type: Number,
      default: 0,
    },
    orderList: {
      type: Array,
      default: ()=>{
        return []
      },
    }
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  activated() {
  },
  methods: {
    
    goOrder(item) {
      orderStatusGoPage(item);
    },
  },
};
</script>

<style lang="less" scoped>
.charge-order-tips {
  position: fixed;
  left: 0;
  top: 1.98rem;
  width: 100%;
  padding: 0 0.2rem;
  box-sizing: border-box;
}
.charge-order-tips .charge-order-tips-box {
  display: flex;
  padding: 0 0.3rem 0 0;
  background: #eefff8;
  border-radius: 0.3rem;
  height: 0.6rem;
  box-sizing: border-box;
}
.charge-order-tips.ban-top {
  top: 2.78rem;
  position: absolute;
}
.charge-order-tips .charge-order-icon-box {
  padding: 0.13rem 0.1rem;
}
.charge-order-tips .charge-order-icon {
  width: 0.34rem;
  height: 0.34rem;
  vertical-align: top;
}
.charge-order-tips .charge-order-flex {
  flex: 1;
  font-size: 0.2rem;
  line-height: 0.28rem;
  color: #017243;
  display: flex;
}
.charge-order-tips .charge-order-flex .swiper-box {
  height: 100%;
}
.charge-order-tips .charge-order-flex .charge-order-len,
.charge-order-tips .charge-order-flex .order-item {
  padding: 0.16rem 0;
}
.charge-order-tips .charge-order-flex .charge-soc {
  margin-left: 0.1rem;
}
.charge-order-tips .charge-order-flex .order-list {
  flex: 1;
  overflow: hidden;
}
.charge-order-tips .right-arrow {
  width: 0.15rem;
  height: 0.15rem;
  display: inline-block;
  border-bottom: 0.03rem solid #017243;
  border-left: 0.03rem solid #017243;
  transform: rotate(-135deg);
  vertical-align: middle;
  transition: all 0.25s;
}
</style>
